import { useState, useEffect } from "react";
import axios from "axios";
import FormGeneralSettings from "./FormGeneralSettings";
import MetaFieldList from "./MetaFieldList";
import { URL_LIST_ALL } from "../configs/api";
import AkkhorLayout from "../layout/akkhor";
import { Link, useParams } from "react-router-dom";

export default function FormBuilderPage({ formId }) {
    const [formData, setFormData] = useState({
        title: "",
        alias: "",
        description: "",
        timestart: "",
        timeend: "",
        status: 1,
    });

    const [metaFields, setMetaFields] = useState([]);

    // Load dữ liệu form nếu đang edit
    useEffect(() => {
        if (formId) {
            axios.get(`${URL_LIST_ALL}/api/blue_forms/${formId}`).then((res) => {
                setFormData(res.data.form);
                setMetaFields(res.data.fields);
            });
        }
    }, [formId]);

    const handleSaveForm = async () => {
        try {
            let res;
            if (formId) {
                res = await axios.put(`/api/blue_forms/${formId}`, { ...formData, fields: metaFields });
            } else {
                res = await axios.post(`/api/blue_forms`, { ...formData, fields: metaFields });
            }
            alert("Lưu thành công!");
        } catch (err) {
            console.error(err);
            alert("Có lỗi xảy ra khi lưu form");
        }
    };

    return (
        <AkkhorLayout idrole="list-chucvu">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/blue-form">Quản lý Form</Link>
                    </li>
                    <li>{formId ? 'Sửa form' : 'Thêm mới form'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Blue Form</h3>
                        </div>
                    </div>
                    <div className="p-6 max-w-4xl mx-auto space-y-6">
                        <h1 className="text-2xl font-bold">Cài đặt Form</h1>

                        <FormGeneralSettings formData={formData} setFormData={setFormData} />

                        <MetaFieldList fields={metaFields} setFields={setMetaFields} />

                        <button
                            onClick={handleSaveForm}
                            className="bg-green-600 text-white px-4 py-2 rounded-lg"
                        >
                            Lưu form
                        </button>
                    </div>
                </div>
            </div>
        </AkkhorLayout>
    );
}
